module.exports = __webpack_public_path__ + "group_buy/groupbuy_step2-c0079b7503e0186d39b350400072fab4.png";